export const Nome = (nome = "") => {
  let split = nome.trim().split(" ");

  if (split.length > 1) return split[0] + " " + split.pop();
  else return split;
};


export const MoedaBr = (dados, real = true) => {
  if (!dados) dados = 0;
  if (real) {
    return dados.toLocaleString("pt-br", {
      style: "currency",
      currency: "BRL",
    });
  } else {
    return dados.toLocaleString("pt-BR", { minimumFractionDigits: 2 });
  }
};